import { graphql } from "@/graphql/codegen/gql"

graphql(`
  query GetProductCostBreakdownList($input: ProductWarehouseListInput) {
    product {
      listByProductWarehouse(input: $input) {
        __typename
        ... on ProductWarehouseListSuccess {
          items {
            bareCost
            freightIn
            laidDownCost
            laidDownDate
            lastReceiptDate
            product {
              productId
              versionId
              versions {
                id
                versionNumber
                status
                releaseDate
              }
            }
            warehouse {
              warehouseAreaId
              externalSystemId
              location {
                locationId
                description
              }
            }
            goodsReceipt {
              ...GoodsReceiptWithCostBreakdownFields
              ...GoodsReceiptPurchaseOrderFields
              productDetails {
                ...GoodsReceiptProductDetailFields
              }
            }
          }
          pageInfo {
            total
            offset
            limit
          }
        }
        ... on ProductWarehouseListFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  query GetPurchasingCostList($input: GetPurchasingCostListInput!) {
    priceChange {
      getPurchasingCostList(input: $input) {
        __typename
        ... on GetPurchasingCostListSuccess {
          entries {
            ...PurchasingCostListEntryFields
          }
        }
        ... on GetPurchasingCostListFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
